import { createApp } from 'vue';
import PsdToJpgConverter from '@/Components/PsdToJpgConverter.vue';
import '@styles/app.css';

createApp(PsdToJpgConverter).mount('#psd-to-jpg-converter');
